import { defaultThClass } from '../../../../config'

const defaultClass = {
  tdClass: '!font-[400] text-[#333333]',
  class: `${defaultThClass} !text-[14px] !min-w-[180px] !text-[#333333] !align-middle`,
}

export const fieldsDetailProduct = [
  {
    key: 'product_name',
    label: 'Produk',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass: defaultClass.class,
    tdClass: `${defaultClass.tdClass} h-auto flex items-center`,
  },
]

export const fieldsDetailBundling = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: `${defaultClass.class} !min-w-[280px] !text-sm`,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass: `${defaultClass.class} !text-sm`,
    tdClass: defaultClass.tdClass,
  },
]
